// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Tooltip, Typography } from '@mui/material';
import { useCopyToClipboard } from './useCopyToClipboard';

const CopyableText = ({ value }: { value: string }) => {
  const copy = useCopyToClipboard();
  return (
    <Tooltip title={`click to copy: ${value}`}>
      <Typography
        onClick={(e) => {
          e.stopPropagation();
          copy(value);
        }}
        sx={{
          maxWidth: '200px',
          cursor: 'pointer',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
        }}
        variant="body2"
      >
        {value}
      </Typography>
    </Tooltip>
  );
};

export default CopyableText;
